import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField } from "components";
import InfoTooltip from "components/InfoTooltip";
import { MenuMultiCheckBox } from 'components/MenuMultiCheckBox/MenuMultiCheckBox';
import SearchComp from "components/Searchcomponent";
import Button from "components/button/Button";
import { useFormik } from "formik";
import { getCurrency, getDateFormat, getDateFormatForDatePicket } from "helper";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import styled from "styled-components";
import { DateFormetContext } from "../../../../app/App.js";

const InputContent = styled.label`
  position: relative;
  span {
    position: absolute;
    right: 6%;
    top: 43%;
    padding-right: 10px;
    color: #c7c7d2;
    user-select: none;
    cursor: text;
  }
`;
export const FiltterDeposits = ({
  filter,
  onSearchChange,
  onLedgerAccountChange,
  onSubLedgerAccountChange,
  setDateRange,
  startDate,
  endDate,
  onAmountChange,
  type,
  setFilters,
  setDueDateRange,
  startDue,
  endDue,
  setGoFilter,
  goFilter,
  isLoading
}) => {
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: { all_ledger_sub_data: [], ledger: [], subLedger: [] },
    validationSchema: "",
    onSubmit: async (values) => { },
  });

  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();


  const [onSearch, setOnSearch] = useState("");
  const [ledgers, setLedgers] = useState([]);

  const { searchAction } = useSearch({ action: setOnSearch });
  const [date, setDate] = useState([]);
  const [date2, setDate2] = useState([]);

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error('End Date should be greater than start date.')
      setDateRange([null, null]);
      setDate([]);
    }

  }, [endDate])

  useEffect(() => {
    setDate([]);
    setDate2([]);
  }, [type])


  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item.ledger_name,
        value: item._id,
      };
    });
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    async function getLedgeraccounts() {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ['Select All', ...res?.ledgers]
        setLedgers(arrayWithSelectAll);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const selectControlStyles = {
    backgroundColor: "#FFFFFF",
    borderColor: "#FFFFFF",
    color: "#b5b5c3",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  useEffect(() => {
    onLedgerAccountChange(formik.values?.ledger);
    onSubLedgerAccountChange(formik.values?.subLedger);

  }, [formik.values]);

  const onLedgerChange = (e) => {
    formik.setFieldValue("ledger", e);
    onLedgerAccountChange(e);
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,2}[0-9]{0,1})/s;

  useEffect(() => {
    formik.setFieldValue("amount", "");
    formik.setFieldValue("ledger", []);
    formik.setFieldValue("subLedger", []);
    formik.setFieldValue("all_ledger_sub_data", []);
  }, [type])
  const onFilterClear = () => {
    formik.setFieldValue("ledger", []);
    formik.setFieldValue("subLedger", []);
    formik.setFieldValue("all_ledger_sub_data", []);
    formik.setFieldValue("amount", "");
    formik.setFieldValue("charge_date", "");
    formik.setFieldValue("paid_at", "");
    formik.setFieldValue("search", "");
    setDueDateRange([null, null]);
    setDate2([]);
    setDateRange([null, null]);
    setDate([]);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_date: "",
        paid_at: "",
        amount: "",
        ledger: [],
        subLedger: []
      },
      search: ""
    }))
  };

  return (
    <div style={{
      marginBottom: "15px"
    }}>
    <div className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12 d-flex activated-ledger d-flex flex-column flex-lg-row justify-content-between p-0" style={{
      marginTop: "15px"
    }} >
        <div
          className={`col-mb-3 col-xs-12 col-lg-3 col-sm-12 sub-header-functions pt-4 pb-3  pl-0 search-input-deposit`}
        >
          <SearchComp
            value={filter?.search}
            setSearchText={onSearchChange}
            style={{ backgroundColor: "#fff !important" }}
            placeholder="Search by transaction #, name"
          />
        </div>
        {type !== "payment" && (
          <div className="col-mb-3 col-xs-12 col-lg-3 col-sm-12 pl-0 paid-date-input-deposit charged_date">
            <LabelField title={"Due Date"} />
            <DateRangePicker
              format={dateFormate}
              placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
              cleanable={true}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              style={{
                display: "inline-block",
                padding: "0",
                border: "0",
                width: "100%",
                color: "black",
              }}
              size="lg"
              value={date2}
              onChange={(update) => { setDueDateRange(update); setDate2(update) }}
            />
            {startDue && endDue && <div style={{
              position: "absolute",
              top: "45px",
              right: "20px",
              color: "#8080da",
              cursor: 'pointer',
              zIndex: "99999999",
            }} onClick={() => { setDueDateRange([null, null]); setDate2([]) }
            }>clear</div>}
          </div>
        )}
        {type === "payment" && (
          <div className="col-mb-3 col-xs-12 col-lg-3 col-sm-12 pl-0 paid-date-input-deposit charged_date">
            <LabelField title={"Paid Date"} />
            <DateRangePicker format={"MM/dd/yyyy"}
              placeholder={"mm/dd/yyyy  ~  mm/dd/yyyy"}
              cleanable={true}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              style={
                {
                  display: "inline-block",
                  padding: '0',
                  border: '0',
                  width: "100%",
                  color: 'black'
                }
              }
              size="lg"
              value={date}
              onChange={(update) => { setDateRange(update); setDate(update) }} />
            {startDate && endDate && <div style={{
              position: "absolute",
              top: "45px",
              right: "20px",
              color: "#8080da",
              cursor: 'pointer',
              zIndex: "99999999",
            }} onClick={() => { setDateRange([null, null]); setDate([]) }
            }>clear</div>}
          </div>
        )}

        <div className="col-mb-3 col-xs-12 col-lg-3 col-sm-12 pl-0">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LabelField title={"Ledger Account"} />
            <InfoTooltip text="Filter deposits by one or more ledger accounts. Select multiple to see deposits across all of them." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <MenuMultiCheckBox Items={ledgers} formik={formik} loading={isLoading} isLedger={true} field='all_ledger_sub_data' width={"100%"} height={48} />
        </div>
        <div className="col-mb-2 col-xs-12 col-lg-2 col-sm-12 pr-0 pl-0">
          <InputContent>
            <InputField
              {...{
                formik,
                title: "Amount",
                name: "amount",
                placeholder: "Amount",
                value: filter?.filter?.amount,
              }}
              type="number"
              style={{ backgroundColor: "#fff", height: "48px" }}
              step="0.01"
              onKeyDown={(e) => preventArrows(e)}
              handleChange={(e) => onAmountChange(e.target?.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
            {!filter?.filter?.amount && <span className="mt-4">{currency}</span>}
          </InputContent>
        </div>
     </div>
    <div className="d-flex align-items-center justify-content-end" style={{
      gap: "10px",
    }}>
      <Button
        variant="primary-outline"
        onClick={onFilterClear}
        disabled={isLoading}
        size="md"
        style={{
          width: "70px",
        }}
      >
        Clear
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          setGoFilter(!goFilter);
        }}
        disabled={isLoading}
        size="md"
        style={{
          width: "70px",
        }}
      >
        Go
      </Button>
    </div>
    </div>
  );
};

